import React from 'react';
import { Modal } from 'react-bootstrap';
import { Warning48Filled } from '@fluentui/react-icons';
import { createMultiTabInstanceCoordinator } from '../../../utils/multiTabInstanceCoordinator';
import styles from './DuplicateTabModal.module.css';

/**
 * Shown when this tab became inactive and a newer app tab exists in the same browser.
 * Only mounted for authenticated sessions (see index.js).
 */
const DuplicateTabModal = () => {
    const [open, setOpen] = React.useState(false);

    React.useEffect(() => {
        const dispose = createMultiTabInstanceCoordinator({
            onStaleFocus: () => setOpen(true),
            onStaleCleared: () => setOpen(false),
        });
        return dispose;
    }, []);

    const handleReload = () => {
        window.location.reload();
    };

    return (
        <Modal
            show={open}
            onHide={() => {}}
            backdrop="static"
            keyboard={false}
            centered
            backdropClassName={styles.backdrop}
            className={styles.modalRoot}
            dialogClassName={styles.dialog}>
            <Modal.Body className={styles.body}>
                <div className="mb-3 text-center">
                    <Warning48Filled color="var(--Brand-Primary)" />
                </div>
                <div className="">
                    <h5 className={styles.title}>This Window Is No Longer Active</h5>
                    <p className={styles.message}>Lens is currently active in another window or tab. To prevent conflicting changes, this window has been paused. </p>
                </div>
                <br />
                <div className="d-flex justify-content-center align-items-center pt-2">
                    <button type="button" className={styles.primaryBtn} onClick={handleReload}>
                        Refresh This Window
                    </button>
                    {/* <span className={styles.linkText}></span> */}
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default DuplicateTabModal;
